export default {
  title: 'Paramètres',
  subtitle: 'Personnalisez vos préférences d\'application.',
  saveSettings: 'Enregistrer les paramètres',
  settingsSaved: 'Paramètres enregistrés avec succès',

  // Notifications section
  notifications: {
    title: 'Notifications',
    enable: 'Activer les notifications',
    email: 'Notifications par email',
    emailDesc: 'Recevoir des notifications par email pour les événements importants',
    inApp: 'Notifications dans l\'application',
    inAppDesc: 'Afficher les notifications dans l\'interface de l\'application',
    lateReturn: 'Alertes de retour tardif',
    lateReturnDesc: 'Recevoir des alertes pour les retours tardifs',
    options: 'Options de notification'
  },

  // Language section
  language: {
    title: 'Langue et région',
    selectLanguage: 'Sélectionner la langue',
    currentLanguage: 'Langue actuelle',
    english: 'English',
    french: 'Français'
  }
};
